enum ELocale {
  DE_DE = 'de_DE',
  DE_AT = 'de_AT',
  DE_CH = 'de_CH',
}

export default ELocale
